import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import Home from '../Home';
import ArchiveWizard from './ArchiveWizard';

// "/archive": the Home with the "Ajouter un document" modal open on top
// (XD screens 3, 4 and 5), just as "/create-user" is the users
// list with the create modal. Closing the modal returns to "/my-documents".
//
// It replaces the Archive → Step2WithQRCode / Step2WithoutQRCode flow, whose
// pages were removed ("/archive-secured" and "/archive-unsecured"
// redirect here).

export { SESSION_STORAGE_ARCHIVE_SUCCESS_KEY } from './constants';

const Archive: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'ArchivOs - Ajouter un document';
  }, []);

  return (
    <Home scope="me" hideTiles>
      <ArchiveWizard open onClose={() => navigate('/my-documents')} />
    </Home>
  );
};

export default Archive;
